// Generated by CoffeeScript 2.7.0
var TimeSpanMixin;

export default TimeSpanMixin = {
  props: {
    duration: {
      type: String,
      default: ''
    },
    customClass: [String, Array],
    allowedTimeUnit: {
      type: Array,
      default: function() {
        return ['minutes', 'hours', 'days'];
      }
    }
  },
  data: function() {
    return {
      value: null,
      unit: null
    };
  },
  created: function() {
    return this.reset();
  },
  methods: {
    reset: function() {
      var e, result, value;
      try {
        result = Duration.parse(this.duration);
        value = _.find(result, function(value, key) {
          if (key === 'direction') {
            return;
          }
          return value;
        });
      } catch (error) {
        e = error;
        value = null;
        result = {};
      }
      this.value = value || null;
      return this.unit = (_.findKey(result, function(_value) {
        return _value === value;
      })) || this.allowedTimeUnit[1];
    },
    updateValue: function(event) {
      this.value = event.target.value;
      return this.emitChangeEvent();
    },
    unitChangeFunc: function(unit) {
      this.unit = unit;
      return this.emitChangeEvent();
    },
    emitChangeEvent: function() {
      var duration;
      duration = new Duration(_.tap({}, (obj) => {
        return obj[this.unit] = this.value;
      }));
      return this.$emit('valueChanged', duration.iso8601());
    }
  }
};
